import i18n from 'i18next';
import { parseISO, parse } from 'date-fns';
import { GraphQLError } from 'graphql/error/GraphQLError';
import { isExistI18nTranslate } from '../utils';
import { UserLoyaltyCardLevels } from '@websky/graphql';

const ISO_DATE_REGEX = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)\+(\d{2}):(\d{2})$/;

interface GraphQLErrorWithDebugMessage extends GraphQLError {
	debugMessage?: string;
}

interface Error {
	message: string;
	translation?: string;
}

// TODO: remove this function when php will send the date ISO format
export const parseDate = (date: string): Date => {
	if (ISO_DATE_REGEX.test(date)) {
		return parseISO(date);
	}

	return parse(date, 'HH:mm dd.MM.yyyy', new Date());
};

export const formatError = (error: any): string => {
	const errors: Error[] = [
		{ message: 'Неверные данные карты лояльности', translation: 'Incorrect card number or password' },
		{ message: 'This auth type is already being used in another account' },
		{ message: 'The use of a loyalty card is prohibited' }
	];

	const graphqlErrors = error['graphQLErrors'] as GraphQLErrorWithDebugMessage[];

	const graphqlError = errors?.find(error =>
		graphqlErrors?.find(graphqlError =>
			(graphqlError.message || graphqlError.debugMessage)?.includes(error['message'])
		)
	);

	return graphqlError ? graphqlError.translation ?? graphqlError.message : graphqlErrors[0].message;
};

export const getCorporateNumber = (number: string) => {
	return `70000${number}`;
};

export const getIsCorporateNumber = (number?: string) => {
	return number?.startsWith('70000');
};

export const getCorporateCardNumberAsNormal = (number?: string) => {
	return number?.replace('70000', '');
};

export const getLevelTrans = (level: UserLoyaltyCardLevels, prefix?: string) =>
	isExistI18nTranslate(`${prefix || ''}_${level}`, { ns: 'Loyalty' })
		? i18n.t(`Loyalty:${prefix || ''}_${level}`)
		: i18n.t(level, { ns: 'Loyalty' });
